import "./CommandsTemplate.css";
import React from "react";
import {
  Snackbar,
  Stack,
  Grid,
  Tabs,
  Tab,
} from "@mui/material";
import { CommandContextStore } from "../context/CommandContext";
import { CommandTab } from "./CommandTab";
import { Box } from "@mui/system";
import { BlueTab } from "./BlueTab";
import { CommandsContent } from "./CommandsContent"
import { useLocation } from 'react-router-dom';;
const { useState, useEffect } = React;



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export const CommandsTemplate = () => {
  const commandContext = React.useContext(CommandContextStore);
  const [open, setOpen] = useState(false);
  const [cmds, setCmds] = useState([]);
  const [tab, setTab] = useState(0);
  const [mountedCommandCount, setMountedCommandCount] = useState(0);
  let location = useLocation();

  const handleCommandTabMount = () => {
    setMountedCommandCount((count) => count + 1);
  };

  function scrollIntoCmdSection(id, headerOffset=150){
    const element = document.getElementById(id);
    if (element) {
      console.log("SCROLLING");
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;  
      window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
      });
  }
}

  function getCurrentProjectFromContext() {
    const toolNmae = commandContext.breadcrumbs[0];
    return toolName;
  }

  useEffect(() => {
    console.log("commandContext", commandContext)
    console.log("CMDS", cmds)
    const locHash = location.hash.slice(1)
    if (locHash.includes("command")) {
      scrollIntoCmdSection(locHash);
    }
  }, [location.hash]);

  useEffect(() => {
    if (mountedCommandCount >= cmds.length) {
      console.log("All CommandTabs have mounted");
      if (location.hash) {
        scrollIntoCmdSection(location.hash.slice(1));
        // setMountedCommandCount(0);
        // setCmds([]);
      }
    }
  }, [mountedCommandCount, location.search]);


  const filterSections = (sections) => {
    const filtered = sections.filter((section) =>
      section.labels.contains(commandContext.labels)
    );
    return filtered;
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const newUpdateCommands = () => {
    let filteredSections = filterSections(commandContext.sections);
    let updatedSections = filteredSections.map((section, index) => {
      let params = [].concat(section.required_flags);

      let selectedOptParams = commandContext.rendered.selectedOpt.filter((p) =>
        section.optional_flags.includes(p)
      );
      params = params.concat(selectedOptParams);
      params = [...new Set(params)];

      let cmd = params.map((p) => commandContext.rendered.rendered[p]).join(" ");

      let cmds = commandContext.languages.map((lang) => {
        return {
          language: lang.name,
          command: `${lang.prefix} ${section.verb} ${cmd}`,
        };
      });

      return {
        name: section.name,
        index: index,
        commands: cmds,
        mitre: section.mitre,
      };
    });
    setCmds(updatedSections);
  };

  React.useEffect(() => {
    try {
      newUpdateCommands();
    } catch {
      commandContext.dispatch({ type: "PUBLISH_ERROR", data: {} });
    }
  }, [commandContext.rendered]);

  React.useEffect(() => {
    handleClick();
  }, [commandContext.copied]);

  React.useEffect(() => {
    try {
      newUpdateCommands();
    } catch {
      commandContext.dispatch({ type: "PUBLISH_ERROR", data: {} });
    }
  }, [commandContext.sections]);

  React.useEffect(() => {
    try {
      newUpdateCommands();
    } catch {
      commandContext.dispatch({ type: "PUBLISH_ERROR", data: {} });
    }
  }, [commandContext.labels]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="stretch"
        marginBottom="3rem"
      >
        {/* Content menu */}
        <Grid item xs={3}>
          <div className="content-nav-fath">
            <div className="content-nav-title">Content</div>
            <CommandsContent commands={cmds} />
          </div>
        </Grid>

        {/* List of commands templates */}
        <Grid
          item
          xs={9}
          style={{
            boxShadow:
              tab === 0
                ? "0.1em 0 0.5em #740000, -0.1em 0 0.5em #740000"
                : "0.1em 0 0.5em #000074, -0.1em 0 0.5em #000074",
            padding: "1rem",
          }}
        >
          <Box>
            <Tabs
              value={tab}
              onChange={(event, value) => {
                setTab(value);
              }}
              variant="scrollable"
              scrollButtons={false}
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
              style={{
                borderBottom: "2px solid rgba(227,227,227,0.699301)",
              }}
            >
              <Tab key={"red"} label="red" />
              <Tab key={"blue"} label="blue" />
            </Tabs>
          </Box>
          <TabPanel key={"red"} value={tab} index={0}>
            <Stack spacing={2} direction="column" alignItems="stretch">
                {cmds.map((command, index) => {
                return (
                    <div
                        id={"command" + index}
                        key={index}
                        style={{ paddingTop: "2vh" }}
                        >
                        <CommandTab key={index} section={command} onMount={handleCommandTabMount}/>
                    </div>
                );
                })}
            </Stack>
          </TabPanel>
          <TabPanel key={"blue"} value={tab} index={1}>
            <BlueTab sigmaURL={commandContext.sigmaRulesURL} />
          </TabPanel>
        </Grid>
      </Grid>

      {/* Snackbar to popup on copy */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        message="Copied"
      />
    </>
  );
};
